var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.959,
    height: 30.408,
    viewBox: "0 0 22.959 20.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning_orange",
    "data-name": "warning orange",
    transform: "translate(-19.072 -22.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38048",
    "data-name": "Path 38048",
    d: "M28.856,23.687l-9.521,16.49a1.959,1.959,0,0,0,1.7,2.939H40.073a1.959,1.959,0,0,0,1.7-2.939l-9.52-16.49a1.959,1.959,0,0,0-3.392,0Z",
    transform: "translate(0 0)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13274",
    "data-name": "Group 13274",
    transform: "translate(29.321 28.773)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4626",
    "data-name": "Rectangle 4626",
    width: 2.463,
    height: 7.507,
    rx: 1.231,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2652",
    "data-name": "Ellipse 2652",
    cx: 1.231,
    cy: 1.231,
    r: 1.231,
    transform: "translate(0 9.241)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.6d674f2d.svg";
export { ForwardRef as ReactComponent };